import { render, staticRenderFns } from "./MerchantItem.vue?vue&type=template&id=5323a8dd&scoped=true"
import script from "./MerchantItem.vue?vue&type=script&lang=js"
export * from "./MerchantItem.vue?vue&type=script&lang=js"
import style0 from "./MerchantItem.vue?vue&type=style&index=0&id=5323a8dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323a8dd",
  null
  
)

export default component.exports